import type { LocationQueryValue, RouteLocationNormalized } from 'vue-router';
import { getIdFromSlug } from '@core/utilities/slug';

/**
 * A query param can arrive repeated (`?email=a&email=b`), which vue-router
 * surfaces as an array where URLSearchParams.get() would yield just the first
 * value. Collapse to that first value so a hand-crafted duplicate can never
 * reach a component as an array.
 */
function firstQueryValue(value: LocationQueryValue | LocationQueryValue[] | undefined): string {
  const single = Array.isArray(value) ? value[0] : value;

  return single ?? '';
}

export function brandRegistrationPropsParser(route: RouteLocationNormalized): {
  email: string;
  verificationToken: string;
} {
  return {
    email: firstQueryValue(route.query.email),
    verificationToken: firstQueryValue(route.query.email_verification_token),
  };
}

export function productCollectionPropsParser(route) {
  return {
    brandId: getIdFromSlug(route.params.brand),
    collectionId: getIdFromSlug(route.params.collectionSlug),
  };
}

export function brandPropsParser(route) {
  return {
    brandId: parseInt(route.params.brand.split('-').slice(-1)[0], 10),
  };
}

export function productPropsParser(route) {
  return {
    productId: parseInt(route.params.product.split('-').slice(-1)[0], 10),
  };
}

export function paymentsPropsParser(route) {
  if (!route.params.tab || route.params.tab === '') {
    return {
      tab: 'orders',
    };
  } else {
    return {
      tab: route.params.tab,
    };
  }
}

export function hasRoute(router, regex) {
  const isPathMatch = window.location.href.match(regex);
  // NOTE: Since we are not using router-view on all pages, we have to use a native link instead of router-link.
  return typeof router !== 'undefined' && !isPathMatch;
}
